import blumeFlowerUrl from '../../../../packages/sidecar/ui/src/assets/flower-icons/blue-forgetmenot.png?url'

export { blumeFlowerUrl }

/** Keep browser chrome and the in-app home mark on one canonical asset URL. */
export function installBrandIcons(document: Document): void {
  for (const rel of ['icon', 'apple-touch-icon'] as const) {
    const selector = `link[rel="${rel}"]`
    const link =
      document.head.querySelector<HTMLLinkElement>(selector) ?? document.createElement('link')
    link.rel = rel
    link.type = 'image/png'
    link.href = blumeFlowerUrl
    if (!link.isConnected) document.head.append(link)
  }
}
